import React from 'react'

const CountText = ({ text }) => <span className="a-count-text">{text}</span>;

export default CountText
